<template>
    <div class="parques">
        <h2 class="subheading grey--text">{{ $t('Parques') }}</h2>
        <v-container class="my-5">
            <!--     Diálogo Modal Persistente para Recortar Logotipo del Parque Industrial      -->
            <v-dialog v-model="dialogImageLogo" persistent scrollable max-width="800px">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('recortar_imagen')}}
                        </v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <clipper-basic
                                mode="normal"
                                class="basic lg"
                                ref="clipperImageLogo"
                                :src="imageFrontURL">
                        </clipper-basic>
                    </v-card-text>
                    <v-card-actions class="justify-center">
                        <v-btn
                                color="primary"
                                @click="getCutingLogo()"
                        >{{$t('recortar')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogFloor" persistent scrollable max-width="400px">
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{update === true ? $t('change_floor') :$t('add_floor')}}
                        </v-toolbar-title>
                        <v-spacer/>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogFloor = false, clear()"
                        >
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-form @submit.prevent="update ? updateFloor() : createFloor()">
                            <v-text-field
                                v-model="floorNumber"
                                prepend-icon="elevator"
                                name="floorNumber"
                                :label="$t('num_piso')"
                                :error-messages="errores.floorNumber"
                            >
                            </v-text-field>
                            <v-text-field
                                v-model="accessCode"
                                prepend-icon="qr_code"
                                name="accessCode"
                                :label="$t('access_code')"
                                :error-messages="errores.accessCode"
                            >
                            </v-text-field>
                            <v-card-actions>
                                <v-btn
                                    color="primary "
                                    @click="dialogFloor = false, clear()"
                                >
                                    {{$t('cerrar')}}
                                </v-btn>
                                <v-spacer/>
                                <v-btn
                                    v-if="update"
                                    :loading="loading"
                                    color="primary"
                                    type="submit"
                                >
                                    {{$t('modificar')}}
                                </v-btn>
                                <v-btn
                                        v-else
                                        :loading="loading"
                                        color="primary"
                                        type="submit"
                                >
                                    {{$t('agregar')}}
                                </v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-dialog v-model="dialogFloorByPark" persistent scrollable max-width="500px">
                <v-card class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('floors_park')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogFloorByPark = false">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <div v-if="floorsbyparks.length > 0">
                            <v-list two-line v-for="(item, i) in floorsbyparks" :key="i">
                                <v-list-tile>
                                    <v-list-tile-content>
                                        <v-list-tile-title>{{$t('num_piso')}}: {{item.floorNumber}}</v-list-tile-title>
                                        <v-list-tile-sub-title>{{$t('access_code')}}: {{item.accessCode}}</v-list-tile-sub-title>
                                    </v-list-tile-content>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    medium
                                                    color="gray"
                                                    class="mr-2"
                                                    @click="update = true, id_update = item.id, dialogFloor = true, fillFieldsFloor(item)"

                                            >
                                                edit
                                            </v-icon>
                                        </template>
                                        <span>{{$t('modificar')}}</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-icon
                                                    v-bind="attrs"
                                                    v-on="on"
                                                    medium
                                                    color="red"
                                                    class="mr-2"
                                                    @click="id_update = item.id, deleteFloor()"

                                            >
                                                close
                                            </v-icon>
                                        </template>
                                        <span>{{$t('eliminar')}}</span>
                                    </v-tooltip>
                                </v-list-tile>
                            </v-list>
                        </div>
                        <div v-else>
                            {{$t('msg_no_floors')}}
                        </div>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <!-- Modal para Enviar Invitación -->
            <v-dialog v-model="dialogInvitation" persistent max-width="400px">
                <v-card class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{ invitationForm.is_building ? 'Invitación Administrador Edificio' : 'Invitación Administrador Parque' }}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogInvitation = false, clearInvitationForm()">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-form @submit.prevent="sendAdminInvitation()">
                            <v-text-field
                                    v-model="invitationForm.park_name"
                                    prepend-icon="location_city"
                                    label="Parque"
                                    readonly
                                    class="mb-4"
                            ></v-text-field>
                            <v-text-field
                                    v-model="invitationForm.email"
                                    prepend-icon="email"
                                    label="Email del Administrador *"
                                    type="email"
                                    :error-messages="erroresInvitation.email"
                                    @input="clearInvitationError('email')"
                            ></v-text-field>
                            <v-alert
                                    :value="!!erroresInvitation.general"
                                    color="error"
                                    icon="warning"
                                    outline
                            >
                                {{erroresInvitation.general}}
                            </v-alert>
                            <v-card-actions>
                                <v-btn color="primary" @click="dialogInvitation = false, clearInvitationForm()">{{ $t('cerrar')}}</v-btn>
                                <v-spacer/>
                                <v-btn :loading="loadingInvitation" color="primary" type="submit">Enviar Invitación</v-btn>
                            </v-card-actions>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-dialog>
            <v-layout align-center justify-center fill-height>
                <v-dialog v-model="dialog" persistent max-width="400px">
                    <template v-slot:activator="{ on }">
                        <v-btn color="primary" dark v-on="on" @click="update = false, clean_fields()"> + {{ $t('AnadirParque')}} </v-btn>
                    </template>
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{ $t('Parques')}}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="dialog = false, clear()">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-form @submit.prevent="update ? update_parque(id_update) : alta_parque()">
                                <v-text-field
                                        v-model="name"
                                        v-if="dialog" autofocus
                                        prepend-icon="location_city"
                                        name="name"
                                        :label="$t('nombre') + ' *'"
                                        :error-messages="errores.nombre"
                                >
                                </v-text-field>
                                <v-text-field
                                        v-model="address"
                                        prepend-icon="add_location"
                                        name="address"
                                        :label="$t('direccion') + ' *'"
                                        :error-messages="errores.direccion"
                                >
                                </v-text-field>
                                <v-text-field
                                        v-model="url_map"
                                        prepend-icon="http"
                                        name="url_map"
                                        :label="$t('url_mapa')"
                                        :error-messages="errores.url_map"
                                ></v-text-field>
                                <v-flex xs12 class="edge pt-3 pb-3 pl-3 pr-3">
                                    <v-label>
                                        {{$t('logotipo')}} *
                                    </v-label>
                                    <br>
                                    <v-img
                                            class="pt-3 pb-3"
                                            :src="resultLogoURL"
                                            v-if="resultLogoURL"
                                            width="auto"
                                            height="180"
                                    ></v-img>
                                    <br>
                                    <v-btn
                                            color="primary">
                                        <clipper-upload
                                                @input="dialog = false, dialogImageLogo = true"
                                                accept="image/*"
                                                v-model="imageFrontURL"
                                        >
                                            {{$t('subir_imagen')}}
                                        </clipper-upload>
                                    </v-btn>
                                    <br>
                                    <v-alert
                                            :value="errores.park_logo"
                                            color="error"
                                            icon="warning"
                                            outline
                                    >
                                        {{errores.park_logo}}
                                    </v-alert>
                                </v-flex>
                                <v-text-field
                                        v-model="latitude"
                                        prepend-icon="my_location"
                                        name="latitude"
                                        :label="$t('latitud')"
                                        :error-messages="errores.latitude"
                                ></v-text-field>
                                <v-text-field
                                        v-model="longitude"
                                        prepend-icon="my_location"
                                        name="longitude"
                                        :label="$t('longitud')"
                                        :error-messages="errores.longitude"
                                ></v-text-field>
                                <v-alert
                                        :value=alerta
                                        type="warning"
                                        outline
                                        transition="scale-transition"
                                >
                                    Fallo con el Servidor
                                </v-alert>
                                <v-card-actions>
                                    <v-btn color="primary" @click="clear(), dialog = false">{{ $t('cerrar')}}</v-btn>
                                    <v-spacer/>
                                    <v-btn v-if="update" :loading="loading" color="primary" type="submit">{{ $t('modificar')}}</v-btn>
                                    <v-btn v-else :loading="loading" color="primary" type="submit">{{$t('agregar')}}</v-btn>
                                </v-card-actions>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-dialog>
            </v-layout>
            <v-layout class="my-4" align-center justify-center fill-height>
                <v-flex >
                    <v-card-title>
                        {{ $t('Parques') }}
                        <v-spacer></v-spacer>
                        <v-text-field
                                v-model="search"
                                append-icon="search"
                                :label="$t('Buscar')"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-card-title>
                    <v-data-table
                            :headers="headers"
                            :loading="loading_data_parques"
                            :items="parques"
                            :search="search"
                            :rows-per-page-text="$t('filas_por_pagina')"
                            :rows-per-page-items="[
                            {text: '5', value: 5},
                            {text: '10', value: 10},
                            {text: '25', value: 25},
                            {text: this.$t('todos'),
                            value: -1}]"
                            class="elevation-1"
                    >
                        <template v-slot:items="props">
                            <td class="justify-center layout px-0">
                                <v-icon
                                        medium
                                        class="mr-2"
                                        @click="fill_fields(props.item), update = true, dialog = true, id_update = props.item.id"
                                >
                                    edit
                                </v-icon>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon
                                                medium
                                                class="mr-2"
                                                v-on="on"
                                                @click="update = false, idParque = props.item.id, dialogFloor = true, cleanFieldsFloor()"
                                        >
                                            add
                                        </v-icon>
                                    </template>
                                    <span>{{$t('add_floor')}}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon
                                                medium
                                                class="mr-2"
                                                v-on="on"
                                                @click="idParque = props.item.id, getFloorByPark()"
                                        >
                                            elevator
                                        </v-icon>
                                    </template>
                                    <span>{{$t('show_floors')}}</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon
                                                medium
                                                class="mr-2"
                                                color="primary"
                                                v-on="on"
                                                @click="openInvitationDialog(props.item)"
                                        >
                                            mail
                                        </v-icon>
                                    </template>
                                    <span>{{ props.item.is_building ? 'Invitar administrador edificio' : 'Invitar administrador parque' }}</span>
                                </v-tooltip>
                            </td>
<!--                            <td>{{ props.item.id }}</td>-->
                            <td align="left">{{ props.item.nombre }}</td>
                            <td align="left">{{ props.item.direccion }}</td>
                            <td align="center">
                                <v-img :src="props.item.park_logo">
                                </v-img>
                            </td>
                            <td align="center">{{ props.item.latitude }}</td>
                            <td align="center">{{ props.item.longitude }}</td>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error" icon="warning">
                                {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                            </v-alert>
                        </template>
                        <template v-slot:pageText="props">
                            {{props.rowsPerPage}}
                            {{$t('Parques')}} {{ props.pageStart }} - {{ props.pageStop }} {{$t('prep_de')}} {{ props.itemsLength }}
                        </template>
                    </v-data-table>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    import '@/plugins/axios'
    import store from '@/store'
    import Vue from 'vue'
    import VeeValidate from 'vee-validate'
    import VuejsClipper from 'vuejs-clipper'
    import { mapState} from 'vuex'

    Vue.use(VeeValidate)
    Vue.use(VuejsClipper, {
        components: {
            clipperBasic: 'clipper-basic',
            clipperFixed: 'clipper-fixed',
            clipperUpload: 'clipper-upload'
        }
    })

    export default {
        name: "parques",
        data: () => ({
            alerta: false,
            dialog: false,
            update: false,
            id_update: 0,
            name: '',
            address: '',
            url_map: '',
            latitude: '',
            longitude: '',
            latitudeAux: '',
            longitudeAux: '',
            resultLogoURL: '',
            imageFrontURL: '',
            resultAuxLogoURL: '',
            dialogImageLogo: false,
            errores: [],
            search: '',
            headers:[],
            parques: [],
            loading_data_parques: false,
            loading: false,
            dialogFloor: false,
            idParque: -1,
            floorNumber: '',
            accessCode:'',
            dialogFloorByPark: false,
            floorsbyparks: [],
            dialogInvitation: false,
            loadingInvitation: false,
            invitationForm: {
                park_id: null,
                park_name: '',
                email: '',
                is_building: false
            },
            erroresInvitation: {
                email: [],
                general: ''
            }
        }),
        beforeUpdate(){
            this.headers = [
                {
                    text: this.$t('acciones'),
                    align: 'center',
                    value: 'name',
                    sortable: false
                },
                // {
                //     text: 'ID',
                //     align: 'left',
                //     sortable: true,
                //     value: 'id'
                // },
                {
                    text: this.$t('nombre'),
                    align: 'left',
                    sortable: true,
                    value: 'nombre'
                },
                {
                    text: this.$t('direccion'),
                    align: 'left',
                    sortable: true,
                    value: 'direccion'
                },
                {
                    text: this.$t('logotipo'),
                    align: 'center',
                    sortable: true,
                    value: 'park_logo'
                },
                {
                    text: this.$t('latitud'),
                    align: 'center',
                    sortable: true,
                    value: 'latitude'
                },
                {
                    text: this.$t('longitud'),
                    align: 'center',
                    sortable: true,
                    value: 'longitude'
                }
            ]
        },
        created: function(){
            this.get_parques()
        },
        computed: {
            ...mapState(['language'])
        },
        methods: {
            get_parques: function(){
            this.loading_data_parques = true
            const config = {
                method: 'get',
                url: 'https://empresa-service.intrare.app/parques/',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Token ' + store.getters.getToken
                }
            };
            axios(config)
                .then(response => {
                    this.parques = response.data
                    this.loading_data_parques = false
                })
                .catch(error => {
                    this.loading_data_parques = false
                    console.log(error)
                })
            },
            getFloorByPark () {
                const config = {
                    method: 'get',
                    url: 'https://empresa-service.intrare.app/floorsbypark/' + this.idParque + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    }
                };
                axios(config)
                    .then(response => {
                        this.floorsbyparks = response.data
                        this.dialogFloorByPark = true
                    })
                    .catch(error => {
                        console.log(error)
                    })
            },
            cleanFieldsFloor () {
                this.floorNumber = ''
                this.accessCode = ''
            },
            createFloor () {
              this.loading = true
              this.errores = []
              console.log('Create Floor')
              const config = {
                method: 'post',
                url: 'https://empresa-service.intrare.app/floorsbypark/',
                headers: {
                  'Content-Type': 'application/json',
                  'Accept-Language': this.language ,
                  'authorization': 'Token ' + store.getters.getToken
                },
                data: {
                    floorNumber: this.floorNumber,
                    accessCode: this.accessCode,
                    idPark: this.idParque
                }
              };
              axios(config)
                .then(ok => {
                  this.loading = false
                  this.$store.commit('snackbar_activate_true')
                  this.$store.commit('snackbar_change_message', this.$t('msg_floor_added'))
                  this.dialogFloor = false
                  setTimeout(this.clear, 3000);
                })
                .catch(error => {
                  this.loading = false
                  if(error.response.status == 400
                    && typeof error.response.data == "object"
                    && error.response.data)
                    this.errores = error.response.data
                })
            },
            updateFloor () {
              this.loading = true
              this.errores = []
                const config = {
                    method: 'PATCH',
                    url: 'https://empresa-service.intrare.app/floorsbypark/update&delete/'+ this.id_update + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept-Language': this.language ,
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        floorNumber: this.floorNumber,
                        accessCode: this.accessCode,
                        idPark: this.idParque
                    }
                };
                axios(config)
                    .then(ok => {
                        this.loading = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', this.$t('msg_floor_update'))
                        setTimeout(this.clear, 3000)
                        this.dialogFloor = false
                        this.getFloorByPark()
                    })
                    .catch(error => {
                        this.loading = false
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                    })
            },
            deleteFloor () {
                const config = {
                    method: 'delete',
                    url: 'https://empresa-service.intrare.app/floorsbypark/update&delete/' + this.id_update + '/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                }
                axios(config).then(ok => {
                    this.$store.commit('snackbar_activate_true')
                    this.$store.commit('snackbar_change_color', 'warning')
                    this.$store.commit('snackbar_change_message', this.$t('msg_floor_delete'))
                    setTimeout(this.clear, 3000)
                    this.getFloorByPark()
                })
                    .catch(error => {
                        if(error.response.status == 400
                            && typeof error.response.data == "object"
                            && error.response.data)
                            this.errores = error.response.data
                    })
            },
            alta_parque: function () {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.errores = []
                        this.loading = true
                        const newID = this.$uuid.v4()
                        var bodyFormData = new FormData()
                        var fileImageFront = null

                        bodyFormData.set('nombre', this.name)
                        bodyFormData.set('direccion', this.address)
                        bodyFormData.set('url_map', this.url_map)
                        bodyFormData.set('latitude', this.latitude)
                        bodyFormData.set('longitude', this.longitude)
                        if (this.resultLogoURL !== '' && this.resultLogoURL.length > 6) {
                            fileImageFront = this.dataURLtoFile(this.resultLogoURL, 'logo' + newID + '.jpeg')
                        }
                        bodyFormData.append('park_logo', fileImageFront)

                        const config = {
                            method: 'post',
                            url: 'https://empresa-service.intrare.app/parques/',
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: bodyFormData
                        };
                        axios(config)
                            .then(ok => {
                                this.loading = false
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('mensaje_parque_alta'))
                                this.get_parques()
                                this.dialog = false
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                this.loading = false
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });

            },
            update_parque: function (id) {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.errores = []
                        this.loading = true
                        var bodyFormData = new FormData()
                        var fileImageFront = null

                        bodyFormData.set('nombre', this.name)
                        bodyFormData.set('direccion', this.address)
                        bodyFormData.set('url_map', this.url_map)
                        if (this.latitude !== this.latitudeAux) {
                            bodyFormData.set('latitude', this.latitude)
                        }
                        if (this.longitude !== this.longitudeAux) {
                            bodyFormData.set('longitude', this.longitude)
                        }
                        if (this.resultLogoURL !== this.resultAuxLogoURL) {
                            const newID = this.$uuid.v4()
                            if (this.resultLogoURL !== '' && this.resultLogoURL.length > 6) {
                                fileImageFront = this.dataURLtoFile(this.resultLogoURL, 'logo_update' + newID + '.jpeg')
                            }
                            bodyFormData.append('park_logo', fileImageFront)
                        }
                        const config = {
                            method: 'put',
                            url: 'https://empresa-service.intrare.app/parques/'+ id +'/update/',
                            headers: {
                                'Content-Type': 'multipart/form-data',
                                'Accept-Language': this.language ,
                                'authorization': 'Token ' + store.getters.getToken
                            },
                            data: bodyFormData
                        };
                        axios(config)
                            .then(ok => {
                                this.loading = false
                                this.get_parques()
                                this.$store.commit('snackbar_activate_true')
                                this.$store.commit('snackbar_change_message', this.$t('mensaje_parque_modificado'))
                                this.dialog = false
                                setTimeout(this.clear, 3000);
                            })
                            .catch(error => {
                                this.loading = false
                                if(error.response.status == 400
                                    && typeof error.response.data == "object"
                                    && error.response.data)
                                    this.errores = error.response.data
                            })
                    }
                }).catch((e) => {
                    console.log(e);// Failed
                });
            },
            clear: function () {
                this.alerta = false
                this.errores = []
                this.$validator.reset()
                this.$store.commit('snackbar_activate_false')
                this.$store.commit('snackbar_change_color', 'success')
            },
            fillFieldsFloor (item) {
              this.floorNumber = item.floorNumber
              this.accessCode = item.accessCode
            },
            fill_fields(item){
                this.name = item.nombre
                this.address = item.direccion
                this.url_map = item.url_map
                this.latitude = item.latitude
                this.longitude = item.longitude
                this.latitudeAux = item.latitude
                this.longitudeAux = item.longitude
                this.resultLogoURL = item.park_logo
                this.resultAuxLogoURL = item.park_logo
            },
            clean_fields(){
                this.name = ''
                this.address = ''
                this.url_map = ''
                this.resultLogoURL = ''
                this.latitude = ''
                this.longitude = ''
                this.latitudeAux = ''
                this.longitudeAux = ''
                this.resultAuxLogoURL = ''
            },
            getCutingLogo () {
                console.log('Datos de la imagen = ', this.imageFrontURL.size)
                const canvas = this.$refs.clipperImageLogo.clip() // call component's clip method
                this.resultLogoURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
                console.log(this.resultLogoURL)
                this.dialogImageLogo = false
                this.dialog = true
            },
            dataURLtoFile (dataurl, filename) {
                var arr = dataurl.split(',')
                var mime = arr[0].match(/:(.*?);/)[1]
                var bstr = atob(arr[1])
                var n = bstr.length
                var u8arr = new Uint8Array(n)
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n)
                }
                return new File([u8arr], filename, { type: mime })
            },
            openInvitationDialog (parque) {
                this.invitationForm.park_id = parque.id
                this.invitationForm.park_name = parque.nombre
                this.invitationForm.email = ''
                this.invitationForm.is_building = parque.is_building || false
                this.erroresInvitation = { email: [], general: '' }
                this.dialogInvitation = true
            },
            clearInvitationForm () {
                this.invitationForm = { park_id: null, park_name: '', email: '', is_building: false }
                this.erroresInvitation = { email: [], general: '' }
            },
            clearInvitationError (field) {
                this.erroresInvitation[field] = []
            },
            sendAdminInvitation () {
                this.erroresInvitation = { email: [], general: '' }
                this.loadingInvitation = true

                // Validación básica
                if (!this.invitationForm.email || !this.isValidEmail(this.invitationForm.email)) {
                    this.erroresInvitation.email = ['Email no válido']
                    this.loadingInvitation = false
                    return
                }

                const config = {
                    method: 'post',
                    url: 'https://empresa-service.intrare.app/AdminPark/onboarding/create/',
                    headers: {
                        'Content-Type': 'application/json',
                        'authorization': 'Token ' + store.getters.getToken
                    },
                    data: {
                        park_id: this.invitationForm.park_id,
                        email: this.invitationForm.email
                    }
                }

                axios(config)
                    .then(response => {
                        this.loadingInvitation = false
                        this.$store.commit('snackbar_activate_true')
                        this.$store.commit('snackbar_change_message', 'Invitación enviada correctamente a ' + this.invitationForm.email)
                        this.dialogInvitation = false
                        this.clearInvitationForm()
                        setTimeout(() => this.$store.commit('snackbar_activate_false'), 3000)
                    })
                    .catch(error => {
                        this.loadingInvitation = false
                        if (error.response && error.response.status === 400) {
                            const data = error.response.data
                            if (data.email) {
                                this.erroresInvitation.email = Array.isArray(data.email) ? data.email : [data.email]
                            } else if (data.park_id) {
                                this.erroresInvitation.general = Array.isArray(data.park_id) ? data.park_id[0] : data.park_id
                            } else {
                                this.erroresInvitation.general = 'Error al enviar la invitación'
                            }
                        } else {
                            this.erroresInvitation.general = 'Error al enviar la invitación. Por favor intenta más tarde.'
                        }
                    })
            },
            isValidEmail (email) {
                const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
                return re.test(email)
            }
        }
    }
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #002b48 #002b48 #002b48 #002b48;
        border-width: 3px 3px 3px 3px;
        text-align: center;
        border-style: solid solid solid solid;
    }
</style>
